import { Spinner } from '@common/components';
import { SectionWrapper } from '@common/components/BookingForms/Section';
import { NotesFieldWrapper, TitleText } from '@common/components/NotesField/NotesField.styles';
import {
  StyledTextarea,
  TextAreaLabel,
} from '@common/components/NotesField/TextArea/TextArea.styles';
import { SpaEntityAddExistingGuests } from '@common/components/SpaEntity/components/SpaEntityAddExistingGuests';
import { SpaEntityGuestField } from '@common/components/SpaEntity/components/SpaEntityGuestField';
import { SpaEntityFormValues } from '@common/components/SpaEntity/SpaEntityForm.schema';
import { useTranslations } from '@lang';
import { useFieldArray, useFormContext, useWatch } from 'react-hook-form';
import { Guest } from 'shared-types/Basket';
import { NumberOfGuests } from './AddGuestsForm/NumberOfGuests';

type AddGuestsFormProps = {
  hasEnoughQuantity: boolean;
  minimumGuests: number | null;
  maximumGuests: number | null;
  spaEntity: any;
  guest: Guest;
  existingGuests: Guest[];
  showGenderNeutral?: boolean;
  typeName?: string;
  isItemFetching?: boolean;
  defaultGender?: string;
};

export const AddGuestsForm = ({
  hasEnoughQuantity,
  minimumGuests,
  maximumGuests,
  spaEntity,
  guest,
  existingGuests,
  showGenderNeutral,
  typeName,
  isItemFetching,
  defaultGender,
}: AddGuestsFormProps) => {
  const { t } = useTranslations();
  const { control, register } = useFormContext<SpaEntityFormValues>();
  const { genderSpecific } = spaEntity;

  const fieldArray = useFieldArray({ control, name: 'guests' });
  const guestValues = useWatch({ control, name: 'guests' }) ?? [];

  return hasEnoughQuantity ? (
    <>
      <SectionWrapper>
        <Spinner isActive={isItemFetching} isLocal />
        <NumberOfGuests
          hasEnoughQuantity={hasEnoughQuantity}
          minimumGuests={minimumGuests}
          maximumGuests={maximumGuests}
          typeName={typeName}
        />
        <SpaEntityAddExistingGuests
          fieldArray={fieldArray}
          guestValues={guestValues}
          selectedGuests={guestValues as any}
          existingGuests={existingGuests}
          guest={guest}
          minimumGuests={minimumGuests}
          maximumGuests={maximumGuests}
          isGenderSpecific={genderSpecific}
        />
        <SpaEntityGuestField
          fieldArray={fieldArray}
          minimumGuests={minimumGuests}
          maximumGuests={maximumGuests}
          isGenderSpecific={genderSpecific}
          showGenderNeutral={showGenderNeutral}
          defaultGender={defaultGender}
        />
      </SectionWrapper>
      <NotesFieldWrapper>
        <TitleText>
          <TextAreaLabel htmlFor="notes">{t('additional.notes')}</TextAreaLabel>
          <StyledTextarea
            id="notes"
            placeholder={t('booking.additionnalNotesPlaceholder')}
            {...register('notes')}
          />
        </TitleText>
      </NotesFieldWrapper>
    </>
  ) : null;
};
